import EventBus 		from "@/event-bus"
import sub_workspace1 	from "@/components/workspace/sub_workspaces.vue"
export default {
	name  : "sub_workspace",
	props : [
		"info_to_component",	
		"layout_id_component",
	],
	components : {
		sub_workspace1
	}, // components
	data  : () => ({

		info 				: {},
		info_comp 			: null,
		bus 				: {},
		state 				: "computer", 
		options 			: {
			errors : true
		},
		states 				: {} ,	
		loading 			: false,
		box_shadow_color 	: "", // 
		box_shadow  		: {
			color_error 	: "box-shadow: 0px 0px 1px 2px #ff5252;", // #F08080
			color_success 	: "box-shadow: 0px 0px 1px 2px #4caf50;", // #F08080
			
		},
		show 		: {
			no_signal : true,
		},
		status_log 		: {
			show 	: false,
			title 	: "Log de estado",
			status 	: null,
			rows 	: [],
			raw 	: "{}",
		},
		ffmpeg_log 		: {
			loading 		: false,
			auto 		: false,
			restarting 	: false,
			restartable : false,
			last_action : null,
			device_id 	: null,
			device_name : null,
			service_type: null,
			code 		: null,
			lines 		: [],
			error 		: null,
			timer 		: null,
			updated_at 	: null,
		},
		colors_options 	: [
			{

				key  : "loading",
				text : "loading",
				color : "primary", 		
			},
			{
				key  : "good",
				text : "working",
				color : "success", 		
			},
			{
				key  : "restarting",
				text : "restarting",
				color : "warning", 		
			},
			{
				key  : "error",
				text : "error",
				color : "error", 		
			},
		],
	}), // data


	created(){
		if (this.info_to_component) {
			this.info_comp 	= this.info_to_component;
		} else {
			// Set default structure if no info_to_component is provided
			this.info_comp = {
				manager_id: "my_computer",
				name: "Default Computer"
			};
		}
		
		// Ensure manager_id exists
		if (!this.info_comp.manager_id) {
			this.info_comp.manager_id = "my_computer";
		}
		
		this.get_list();
		console.log("SUB_WORKSPACE CREATED - INFO COMP:", this.info_comp);
		
		/*if (this.render_sub_workspace && this.render_sub_workspace.list_workspaces && this.render_sub_workspace.list_workspaces[this.info_comp.manager]) {
			this.state 		= this.render_sub_workspace.list_workspaces[this.info_comp.manager].computer;//this.$store.state.Workspaces.list_workspaces[this.info_comp.manager]; //this.$Workspaces.get_status(this.info_comp.manager);
		}else{
			this.state 		= "computer";
		}*/
	}, // created



	computed : {
		render_sub_workspace: function(){
			// console.log("store : ", this.$store.getters["Workspaces/state_workspace"])
			// console.log("test", this.$store.state.Workspaces.list_workspaces this.info_comp.manager)//
			// let temp = this.$store.state.Workspaces; 
			// let list = {};
			// console.log("comp ****************** ", this.info_comp.manager_id, this.states)

			/*	if (this.state == "computer" && val.computer ) { // && list && list.computer 
					// console.log("pc : ", list.computer )
					this.state = val.computer//list.computer;
				}
			// if (this.$store.state.Workspaces && this.$store.state.Workspaces.list_workspaces && this.$store.state.Workspaces.list_workspaces[this.info_comp.manager_id]) {
				// list = this.$store.state.Workspaces.list_workspaces[this.info_comp.manager_id];				
			// console.log("charge 1")
			// }else 
			if(this.$store.state.Workspaces && this.$store.state.Workspaces.default && this.$store.state.Workspaces.default.my_computer){
				val = this.$store.state.Workspaces.default.my_computer;
				// list
			}*/
			// return list && list.states ? list.states : {};//this.$store.state.Workspaces ;//this.state.states;
			return this.states;// val && val.states ? val.states : {} 
		}, // render sub workspace

		ffmpeg_log_text: function(){
			if (!this.ffmpeg_log || !this.ffmpeg_log.lines || !this.ffmpeg_log.lines.length) return '';
			return this.ffmpeg_log.lines.map(line => this.mask_sensitive_text(line)).join('\n');
		}, // ffmpeg log text

		
	},

	watch: {
		'status_log.show': function(show){
			if (!show) {
				this.stop_ffmpeg_log();
			}
		},
	},

	methods : {
		open_status_log(device_key, device, status_key, status){
			const device_info = this.$Format && this.$Format.render_device ? this.$Format.render_device(device_key) : null;
			const device_name = this.render_name(device_key, device);
			const device_id = this.resolve_device_id(device_key, device, device_info);
			const code = status && status.code ? status.code : null;
			const translated_code = code ? this.$ml.get(code) : null;
			const status_payload = status ? status : {};
			const service_type = this.resolve_ffmpeg_service_type(status_key, status_payload);

			this.status_log = {
				show 	: true,
				title 	: `${device_name} / ${status_key}`,
				status 	: status_payload,
				rows 	: this.build_status_log_rows({
					device_key,
					device_name,
					device_info,
					status_key,
					status: status_payload,
					code,
					translated_code,
				}),
				raw 	: this.stringify_status_log({
					computer: this.state,
					manager: this.info_comp,
					device_key,
					device_name,
					device_info,
					status_key,
					status: status_payload,
				}),
			};
			this.prepare_ffmpeg_log({ device_id, device_name, service_type, code });
			this.start_ffmpeg_log();
		}, // open status log

		resolve_device_id(device_key, device, device_info){
			if (device_info && device_info.deviceId) return device_info.deviceId;
			if (device && device.deviceId) return device.deviceId;
			return device_key;
		}, // resolve device id

		resolve_ffmpeg_service_type(status_key, status){
			const value = `${status_key || ''} ${status && status.code ? status.code : ''} ${status && status.module ? status.module : ''}`.toUpperCase();
			if (status_key === 'rtsp' || value.includes('AG_BK_RTSP_')) return 'ffprobe_check';
			if (value.includes('CLOUD')) return 'cloud_retransmission';
			if (value.includes('LOCAL')) return 'local_rtsp';
			if (value.includes('PRIVATE')) return 'private';
			if (value.includes('RETRASMISSION')) return 'local_rtsp';
			return null;
		}, // resolve ffmpeg service type

		is_restartable_ffmpeg_service(service_type){
			return ['local_rtsp', 'cloud_retransmission', 'private'].includes(service_type);
		}, // is restartable ffmpeg service

		prepare_ffmpeg_log({ device_id, device_name, service_type, code }){
			this.stop_ffmpeg_log();
			const restartable = this.is_restartable_ffmpeg_service(service_type);
			this.ffmpeg_log = {
				loading 		: false,
				auto 		: false,
				restarting 	: false,
				restartable : restartable,
				last_action : null,
				device_id 	: device_id,
				device_name : device_name,
				service_type: service_type,
				code 		: code,
				lines 		: [],
				error 		: service_type ? null : 'Este estado no parece pertenecer a un servicio ffmpeg reiniciable.',
				timer 		: null,
				updated_at 	: null,
			};
		}, // prepare ffmpeg log

		start_ffmpeg_log(){
			if (!this.ffmpeg_log.device_id || !this.ffmpeg_log.service_type) return;
			this.ffmpeg_log.auto = true;
			this.fetch_ffmpeg_log();
			if (this.ffmpeg_log.timer) clearInterval(this.ffmpeg_log.timer);
			this.ffmpeg_log.timer = setInterval(() => {
				this.fetch_ffmpeg_log();
			}, 2000);
		}, // start ffmpeg log

		stop_ffmpeg_log(){
			if (this.ffmpeg_log && this.ffmpeg_log.timer) {
				clearInterval(this.ffmpeg_log.timer);
			}
			if (this.ffmpeg_log) {
				this.ffmpeg_log.timer = null;
				this.ffmpeg_log.auto = false;
			}
		}, // stop ffmpeg log

		fetch_ffmpeg_log(){
			if (!this.ffmpeg_log.device_id || !this.ffmpeg_log.service_type) return;
			if (this.ffmpeg_log.loading) return;
			const api = this.$URL + "/api/v1/workspace/ffmpeg/log";
			this.ffmpeg_log.loading = true;
			this.$axios.get(api, {
				params: {
					deviceId: this.ffmpeg_log.device_id,
					deviceName: this.ffmpeg_log.device_name,
					serviceType: this.ffmpeg_log.service_type,
					code: this.ffmpeg_log.code,
					lines: 250,
				},
			}).then(res => {
				this.ffmpeg_log.lines = res && res.data && res.data.lines ? res.data.lines.map(line => this.mask_sensitive_text(line)) : [];
				this.ffmpeg_log.updated_at = new Date().toLocaleTimeString();
				this.ffmpeg_log.error = null;
				this.ffmpeg_log.last_action = res && res.data && res.data.exists ? 'Log actualizado' : 'Log todavía no disponible';
			}).catch(error => {
				this.ffmpeg_log.error = error && error.response && error.response.data && error.response.data.msg ? error.response.data.msg : 'No se pudo leer el log ffmpeg';
				this.ffmpeg_log.last_action = 'Error al leer log';
			}).finally(() => {
				this.ffmpeg_log.loading = false;
			});
		}, // fetch ffmpeg log

		restart_ffmpeg_service(){
			if (!this.ffmpeg_log.device_id || !this.ffmpeg_log.service_type || !this.ffmpeg_log.restartable || this.ffmpeg_log.restarting) return;
			const api = this.$URL + "/api/v1/workspace/ffmpeg/restart";
			this.ffmpeg_log.restarting = true;
			this.$axios.post(api, {
				deviceId: this.ffmpeg_log.device_id,
				serviceType: this.ffmpeg_log.service_type,
				code: this.ffmpeg_log.code,
			}).then(() => {
				this.ffmpeg_log.last_action = 'Reinicio solicitado';
				this.fetch_ffmpeg_log();
			}).catch(error => {
				this.ffmpeg_log.error = error && error.response && error.response.data && error.response.data.msg ? error.response.data.msg : 'No se pudo reiniciar ffmpeg';
				this.ffmpeg_log.last_action = 'Error al reiniciar ffmpeg';
			}).finally(() => {
				this.ffmpeg_log.restarting = false;
			});
		}, // restart ffmpeg service

		mask_sensitive_text(value){
			if (value === null || typeof value === 'undefined') return value;
			return String(value)
				.replace(/rtsp:\/\/([^\s:@/]+):([^\s@/]+)@/gi, 'rtsp://$1:***@')
				.replace(/(password|passwd|pwd|token|secret|authorization)(["'\s:=]+)([^,"'\s}]+)/gi, '$1$2***');
		}, // mask sensitive text

		sanitize_status_payload(value){
			if (value === null || typeof value === 'undefined') return value;
			if (typeof value === 'string') return this.mask_sensitive_text(value);
			if (typeof value !== 'object') return value;
			if (Array.isArray(value)) return value.map(item => this.sanitize_status_payload(item));

			const sanitized = {};
			Object.keys(value).forEach(key => {
				const lowered = String(key).toLowerCase();
				if (lowered.includes('password') || lowered.includes('passwd') || lowered.includes('pwd') || lowered.includes('token') || lowered.includes('secret') || lowered.includes('authorization')) {
					sanitized[key] = '***';
					return;
				}
				sanitized[key] = this.sanitize_status_payload(value[key]);
			});
			return sanitized;
		}, // sanitize status payload

		build_status_log_rows({ device_key, device_name, device_info, status_key, status, code, translated_code }){
			return [
				{ key: "computer", label: "Computer", value: this.state },
				{ key: "manager", label: "Manager ID", value: this.info_comp && this.info_comp.manager_id ? this.info_comp.manager_id : "N/A" },
				{ key: "device_key", label: "Device key", value: device_key },
				{ key: "device_name", label: "Device name", value: device_name },
				{ key: "device_id", label: "Device ID", value: device_info && device_info.deviceId ? device_info.deviceId : device_key },
				{ key: "status_key", label: "Status key", value: status_key },
				{ key: "state", label: "State", value: status && typeof status.state !== "undefined" ? status.state : "N/A" },
				{ key: "code", label: "Code", value: code || "N/A" },
				{ key: "message", label: "Message", value: translated_code || (status && status.module ? status.module : "N/A") },
				{ key: "color", label: "Color", value: status && status.color ? status.color : "N/A" },
				{ key: "icon", label: "Icon", value: status && status.icon ? status.icon : "N/A" },
			];
		}, // build status log rows

		stringify_status_log(payload){
			try {
				return JSON.stringify(this.sanitize_status_payload(payload), null, 2);
			} catch (error) {
				return JSON.stringify({ error: "No se pudo serializar el payload", message: error && error.message ? error.message : error }, null, 2);
			}
		}, // stringify status log

		render_name(key, item){
			// console.log("RENDER NAMES --------_____> ", key, item)
			if (key.includes('network')) {
				return "Network"
			}else{
				if (item && item.name) {
					return item.name;
				}else{

					let temp = this.$Format.render_device(key);
					if (temp) {
						return (temp.name).toLowerCase();
					}else{
						return key.toLowerCase();
					}
				}

			}

		}, // render name

		get_list(){
			const api 	= this.$URL + "/api/v1/workspace/state";
			let info_up = { ...this.info_comp };
			
			// Debug: Log the info being sent
			console.log("INFO_COMP:", this.info_comp);
			console.log("INFO_UP being sent:", info_up);
			
			// Validate and set default manager_id if missing
			if (!info_up || !info_up.manager_id) {
				console.warn("Missing manager_id in workspace state request, using default 'my_computer'");
				if (!info_up) {
					info_up = {};
				}
				// Set default manager_id
				info_up.manager_id = "my_computer";
			}
			
			if (this.show.no_signal) {
				this.box_shadow_color  = this.box_shadow && this.box_shadow.color_error ? this.box_shadow.color_error : "";	
			}
			this.$axios.post(api, info_up).then(res => {
				if (res && res.data && !this.loading) {
					this.render_sub_workspace_states({...res.data})
				}
				this.loading = false;
			}).catch(er => {
				this.loading = false;
				console.log("Error get workspace state ", er)
			})
		}, // get list

		check_options(item){
			if (!this.options.errors) {
				return true;
			}else
			if (this.options.errors && item) {
				return true;
			}else{
				return false
			}

		}, // check options
		check_sub_options(item){
			if (!this.options.errors) {
				return true;
			}else
			if (this.options.errors && item && item.state && (item.state == 2 || item.state == 3)) {
				return true;
			}else{
				return false
			}
		}, //  check_sub_options
		start_bus(){
			if (this.info_comp && this.info_comp) {
				let vm 			= this;
				this.loading 	= true;
				// console.log("vm.info_comp.manager_id " , vm.info_comp.manager_id)
				let temp = 'states_workspace_' + vm.info_comp.manager_id;
				EventBus.$on(temp, vm.bus[temp] = (msg)=>{
					if (msg) {
						// console.log("states sub: ", vm.info_comp.manager_id, msg)
						// vm.render_sub_workspace({...msg})
						vm.render_sub_workspace_states({...msg})
						// vm.state = msg; //vm.$Workspaces.get_status(vm.info_comp.key);
						this.loading = false;

					}
				})
			}
		}, // start bus

		render_sub_workspace_states(val){
			// console.log("comp ****************** ", this.info_comp.manager_id, val)
			if (this.show.no_signal) {				
				this.show.no_signal 	= false;				
				this.box_shadow_color  	= this.box_shadow.color_success;
			}
			if (this.state == "computer" && val.computer ) { // && list && list.computer 
				// console.log("pc : ", list.computer )
				this.state = val.computer//list.computer;
			}
			if(!val && this.$store.state.Workspaces && this.$store.state.Workspaces.default && this.$store.state.Workspaces.default.my_computer){
				val = this.$store.state.Workspaces.default.my_computer;
				// list
			}
			this.states = val.states;
		}
	}, // methods
	mounted(){
		this.start_bus();
		
	}, // mounted

	beforeDestroy(){
		this.stop_ffmpeg_log();
		this.$Helper.clear_bus(EventBus, this.bus, "sub_workspace");
	}, // before destroy
};
